import { gql } from '@apollo/client/core';

// eslint-disable-next-line import/prefer-default-export
export const SHARED_JOBS_MUTATION = gql`
  mutation sharedJob($input: SharedJobInput!) {
    sharedJob(input: $input) {
      status
      sharedEmails
      unsharedEmails
      invalidEmailFormat
      invalidEmails
    }
  }
`;

export default {
  SHARED_JOBS_MUTATION,
};
